

<template>
  <div v-show="showVideo" id="fullscreenvideo">
    <video ref="videoElement" @ended="videoEnded" muted playsinline>
      <source v-if="formData.transport == 'car'" src="@/assets/video/webspecial_auto.mp4" type="video/mp4">
      <source v-if="formData.transport == 'plane'" src="@/assets/video/webspecial_flugzeug.mp4" type="video/mp4">
      <source v-if="formData.transport == 'train'" src="@/assets/video/webspecial_zug.mp4" type="video/mp4">
    </video>
    <button
        type="submit"
        ref="nextStepButton"
        class="button nextstep"
        @click="skipVideo"
    >
      <span>{{ $t('formContent.Step6form_button')}}</span>
    </button>
  </div>
</template>
<script>

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // Lokale Kopie der Prop-Daten
      localFormData: {},
      showVideo: false,
    };
  },
  mounted() {
    // Erstellen einer lokalen Kopie der Prop-Daten
    this.localFormData = JSON.parse(JSON.stringify(this.formData));
    this.initView();
  },
  methods: {
    initView() {
      this.showVideo = true; // Video-Container einblenden
      this.$refs.videoElement.play(); // Video abspielen
    },
    videoEnded() {
      this.$emit('update', this.localFormData);
      this.$emit('form-submitted');
    },
    skipVideo() {
      this.$emit('update', this.localFormData);
      this.$emit('form-submitted');
    }

  },
};
</script>
<style scoped lang="scss">

footer {
  display:none !important;
}

#fullscreenvideo {
  display:block;
  video {
    object-position: bottom center;
  }
  button {
    z-index:9999; position:absolute; bottom:15px; right:15px;
    @media screen and (max-width:640px) {
      z-index: 9999;
      position: absolute;
      top: 55px;
      right: 0;
      left: 0px;
      bottom:auto;
      width: max-content !important;
      margin: auto
    }
  }
}
</style>
